<template>
  <main>
    <h2 class="ttl"><img src="/img/ico_pw2.png" alt="パスワード" width="40" class="mb30"><br>{{$t('passwordReset')}}</h2>
    <div class="account-box">
      <p class="txt-pw">
        <span v-if="!$v.newPassword.required || !$v.newPassword.minLength || !$v.newPassword.maxLength || !$v.newPassword.alphaNum || !$v.newPassword.match">
          {{$t(this.getMessage($v.newPassword , {"name" : "パスワード" , "type" : "OnebyOne"}))}}
        </span>
        <span class="txt-info">
          {{$t('passwordRequirement')}}
        </span>
        <input type="password" id="pw" name="pw" placeholder="Password" v-model.trim="$v.newPassword.$model">
      </p>
      <p class="txt-pw">
        <span v-if="!$v.newPasswordVerify.verifyPassword ">{{this.getMessage($v.newPasswordVerify)}}</span>
        <input type="password" id="pw" name="pw" placeholder="Password" v-model="$v.newPasswordVerify.$model">
      </p>
    </div>
    <p class="txt-error center mb40">
      <validationError :error="(this.$v.$invalid && this.vaError)"/>
      <firebaseError :error="this.fbError" :errorCode="errorCode"/>
    </p>
    <p class="btn-normal"><router-link to="" @click.native="updatePassword">{{$t('passwordResetAction')}}</router-link></p>
  </main>
</template>

<script>
import firebase from 'firebase'
import firebaseError from "@/error/FirebaseError"
import validationError from "@/error/ValidationError"
import { required , alphaNum ,  minLength , maxLength} from "vuelidate/lib/validators"

export default {
  name: 'PasswordReset',
  data () {
    return {
      auth: firebase.auth(),
      email: this.$route.query.email,
      actionCode: this.$route.query.action_code,
      newPassword: '',
      newPasswordVerify: '',
      vaError : false, //バリデーションエラー
      fbError : false, //firebaseエラー
      errorCode: "",
    }
  },
  validations: {
    newPassword: {
      required,
      minLength : minLength(8),
      maxLength : maxLength(20),
      alphaNum,
      match () {
        return this.isNotEmpty(this.isMatch(this.newPassword , 'oneByOne' ))
      }
    },
    newPasswordVerify: {
      verifyPassword : required,
    },
  },
  components: {
    firebaseError,
    validationError,
  },
  created () {
    if (!this.email || !this.actionCode) {
      this.$router.push({ name: 'NotFound' })
      return
    }
  },
  methods: {
    async updatePassword () {
      this.$v.$touch()
      if(this.$v.$invalid) {
        this.vaError = true
        return
      }
      if (this.newPassword != this.newPasswordVerify) {
        this.errorCode = "not-match-password"
        this.fbError = true
        return
      }
      try {
        await this.auth.confirmPasswordReset(this.actionCode, this.newPassword)
        await this.auth.signInWithEmailAndPassword(this.email, this.newPassword)
        this.$router.push({ name: 'Home' })
      } catch (error) {
        this.errorCode = error.code
        this.fbError = true
      }
    }
  }
}
</script>
